import { useMemo } from 'react';

/**
 * Hook for environment-based configuration
 * @returns {object} Environment configuration
 */
export const useEnvironmentConfig = () => {
  const config = useMemo(() => {
    const isDev = import.meta.env.DEV;

    return {
      isDev,
      isProd: !isDev,
      backendUrl: isDev ? import.meta.env_VITE_BACKEND_URL_DEV : import.meta.env.VITE_BACKEND_URL_PROD,
      nodeEnv: import.meta.env.MODE,
    };
  }, []);

  return config;
};
